import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import Immutable from "immutable";

export default class SpecialBillForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            placementTaskId: null,
            taskDetails: [],
            disableControls: props.disableControls || false,
        }

        this.setSelectedValue = this.setSelectedValue.bind(this);
        this.getSpecialBill = this.getSpecialBill.bind(this);
        this.updateTaskId = this.updateTaskId.bind(this);
        this.shouldDisableSpecialBill = this.shouldDisableSpecialBill.bind(this);
    }

    updateTaskId(newId, setSelectedValue = false, callback = null) {
        const self = this;
        const clone = Immutable.fromJS(this.state).toJS();
        clone.setSelectedValue = setSelectedValue;
        if (newId && (newId.length > 0 || newId > 0)) {
            ajax.api()
                .get(`get-placement-task-picklists/${newId}`)
                .then(function (res) {
                    let data = res.data;
                    clone.placementTaskId = newId;
                    clone.taskDetails = data;
                    console.log(self.props.initialTaskId, newId);
                    if (self.props.specialBill && self.props.initialTaskId == newId) {
                        for (let k in self.props.specialBill) {
                            for (let i = 0; i < clone.taskDetails.length; i++) {
                                let td = clone.taskDetails[i];
                                if (k.toLowerCase() === td.placementTaskDetail.taskCode.toLowerCase()) {
                                    td.selectedValue = self.props.specialBill[k];
                                    break;
                                }
                            }
                        }
                    }
                    if (self.props.shouldDisable) {
                        if (self.props.shouldDisable === "yes") {
                            clone.disableControls = true;
                        }
                        else {
                            clone.disableControls = false;
                        }

                    }

                    self.setState(clone, callback);
                });
        } else {
            clone.placementTaskId = null;
            clone.taskDetails = [];

            self.setState(clone);
        }

    }

    getSpecialBillWithRequired() {
        const result = {};

        // for (let i = 0; i < this.state.taskDetails.length; i++) {
        //     const td = this.state.taskDetails[i];
        //     result[`${td.placementTaskDetail.taskCode.toLowerCase()}`] = {
        //         value: td.selectedValue === undefined ? null : td.selectedValue,
        //         isRequired: td.placementTaskDetail.required
        //     }
        // }

        if (this.state.disableControls) {
            for (let k in this.props.specialBill) {
                result[k] = {
                    value: this.props.specialBill[k],
                    isRequired: false
                }
            }
        } else {

            for (let i = 0; i < this.state.taskDetails.length; i++) {
                const td = this.state.taskDetails[i];
                result[`${td.placementTaskDetail.taskCode.toLowerCase()}`] = {
                    value: td.selectedValue === undefined ? null : td.selectedValue,
                    isRequired: td.placementTaskDetail.required
                }
            }

        }
        console.log(result);

        return result;
    }

    getSpecialBill() {

        //if (this.shouldDisableSpecialBill(this.state)) return this.props.specialBill;

        const result = {};
        for (let i = 0; i < this.state.taskDetails.length; i++) {
            const td = this.state.taskDetails[i];
            result[`${td.placementTaskDetail.taskCode.toLowerCase()}`] = td.selectedValue === undefined ? "" : td.selectedValue;
        }

        return result;
    }

    setSelectedValue(taskDetailId, value) {
        for (let i = 0; i < this.state.taskDetails.length; i++) {
            const td = this.state.taskDetails[i];
            if (td.placementTaskDetail.placementTaskDetailId === taskDetailId) {
                td.selectedValue = value;
                break;
            }
        }
    }

    componentDidMount() {
        let self = this;
        if (this.props.taskId) {
            this.updateTaskId(this.props.taskId, true, () => {

                // self.setState(Immutable.fromJS(self.state)
                //     .mergeDeep({
                //         disableControls: self.shouldDisableSpecialBill(self.state)
                //     }).toJS());
            });

        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.taskId != this.props.taskId) {
            this.updateTaskId(nextProps.taskId, true);
        }
        if (nextProps.shouldDisable === "yes") {
            this.updateTaskId(nextProps.taskId, true);
        }
    }

    shouldDisableSpecialBill(state) {
        const self = this;
        let result = false;
        if (this.props.taskId == null) result = true;
        else {

            const taskDetails = state.taskDetails;
            const specialBill = self.props.specialBill;

            if (!specialBill) result = false;
            else if (taskDetails && specialBill &&
                (taskDetails.length != Object.keys(specialBill).length)) result = true;
            else {
                for (let i = 0; i < taskDetails.length; i++) {
                    const taskDetail = taskDetails[i].placementTaskDetail;
                    if (specialBill && !specialBill[taskDetail.taskCode.toLowerCase()]) {
                        result = true;
                        break;
                    } else {
                        if (!specialBill) continue;
                        let selectedVal = specialBill[taskDetail.taskCode.toLowerCase()];
                        let pickList = taskDetails[i].pickList;
                        let pickListItem = pickList.find(item => item.taskValue === selectedVal);
                        result = pickListItem == null || pickListItem == undefined;
                        if (result == true) break;

                    }
                }
            }

        }

        if (self.props.toggleTaskCallback) setTimeout(() => self.props.toggleTaskCallback(result), 1);
        return result;
    }

    render() {
        const self = this;

        const taskId = this.state.placementTaskId;

        let content = null;
        if (self.state.disableControls == false) {
            let picklist = this.state.taskDetails.map(td => {
                const requiredMark = td.placementTaskDetail.required ? (<span className="ap-color-red">*</span>) : null;

                let control = td.placementTaskDetail.pickList == 1 ?
                    <FormControl componentClass="select" disabled={this.state.disableControls} onChange={(evt) => self.setSelectedValue(td.placementTaskDetail.placementTaskDetailId, evt.target.value)}
                        defaultValue={td.selectedValue}>
                        <option key="" value="">Please select...</option>
                        {td.pickList.map(pl => <option key={pl.placementTaskDetailPickListID} value={pl.taskValue}>{pl.taskValue}</option>)}
                    </FormControl> :
                    <FormControl disabled={this.state.disableControls} onChange={(evt) => self.setSelectedValue(td.placementTaskDetail.placementTaskDetailId, evt.target.value)}
                        defaultValue={td.selectedValue}>
                    </FormControl>;

                return (<div className="row" key={td.placementTaskDetail.placementTaskDetailId}>
                    <div className="col-md-2 text-right col-xs-6">
                        <ControlLabel>{td.placementTaskDetail.taskCode} {requiredMark}</ControlLabel>
                    </div>
                    <div className="col-md-10">
                        {control}
                    </div>
                </div>);
            });
            content = (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <hr />
                            <span className="ap-h3">Special Bill</span>
                        </div>
                        <div className="col-md-12 ap-top-margined">&nbsp;</div>
                    </div>
                    {picklist}
                </div>
            );
        } else {
            content = []
            for (let key in self.props.specialBill) {

                content.push(
                    (<div className="row" key={key}>
                        <div className="col-md-2 text-right col-xs-6">
                            <ControlLabel>{key.toUpperCase()}</ControlLabel>
                        </div>
                        <div className="col-md-10">
                            <FormControl disabled={self.state.disableControls} defaultValue={self.props.specialBill[key]} />
                        </div>
                    </div>)
                );
            }
        }
        return (
            <div>
                {content}
            </div>
        );
    }
}